@for (call of message().toolCalls; track call.id) {
  <div class="tool-call ds-caption" data-testid="ai-agent-tool-call">
    <soft-ds-icon
      [name]="
        call.status === 'done'
          ? 'fa-regular fa-circle-check'
          : call.status === 'error'
            ? 'fa-regular fa-circle-exclamation'
            : 'fa-regular fa-circle-notch'
      "
      [class.spin]="call.status !== 'done' && call.status !== 'error'"
    />
    <span>
      {{
        (call.status === 'executing'
          ? '#AI_AGENT.TOOL_CLIENT_RUNNING'
          : '#AI_AGENT.TOOL_RUNNING'
        ) | translate
      }}
      {{ call.name }}
    </span>
  </div>
}

@if (message().text.length > 0) {
  <markdown class="answer" [data]="message().text" />
} @else if (message().streaming) {
  <span class="ds-caption">{{ '#AI_AGENT.THINKING' | translate }}</span>
}

@for (entry of cards(); track entry.id) {
  <soft-ai-agent-chart-card [card]="entry.card" />
}
